import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/customerService',
	name: 'customerService',
	meta,
	redirect: {
		name: 'customerService-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'customerServiceList',
			name: `${pre}customerServiceList`,
			component: _import('customerService/customerServiceList'),
			meta: {
				...meta,
				title: '客服列表'
			}
		},
		{
			path: 'customerServiceDetail',
			name: `${pre}customerServiceDetail`,
			component: _import('customerService/customerServiceDetail'),
			meta: {
				...meta,
				title: '我是客服'
			}
		},
	])('customerService-')
}